import { tv } from 'tailwind-variants';

import styles from './popover.module.css';
import { fontStyles } from './typography';

export const popover = tv({
  slots: {
    base: [
      'bg-special-background-modal',
      'border-none',
      'font-heading',
      'mt-2',
      'p-[0.375rem]',
      'max-w-[320px]',
      'min-w-[240px]',
      'overflow-auto',
      'z-[1000]',
      'rounded-lg',
      'shadow-25',
      'origin-top-left',
      styles['base-animation'],
    ],
    learnMore: [
      'bg-special-background-modal',
      'border-none',
      'font-heading',
      'mt-2',
      'p-[0.375rem]',
      'max-w-[332px]',
      'min-w-[240px]',
      'overflow-auto',
      'z-[1000]',
      'rounded-lg',
      'shadow-25',
      'origin-top-left',
      styles['learn-more-animation'],
    ],
    wide: ['w-[320px]'],
    items: ['focus-visible:outline-matcha-purple'],
    itemsLabel: [
      fontStyles({ variant: 'LABEL_SM' }),
      'text-token-gray-1600',
      'items-center',
      'rounded-md',
      'flex',
      'h-10',
      'px-3.5',
    ],
    item: [
      fontStyles({ variant: 'BODY_MD' }),
      'mb-1',
      'items-center',
      'rounded-md',
      'flex',
      'h-10',
      'px-3.5',
      'bg-special-background-modal',
      'outline-none',
      'select-none',
      'text-token-gray-1600',
      'cursor-pointer',
      'hover:bg-token-gray-200',
      'active:bg-token-gray-400',
      'focus:bg-token-gray-200',
      'data-[highlighted]:outline-none',
    ],
    icon: ['h-4', 'mr-3', 'w-4'],
    content: [
      fontStyles({ variant: 'BODY_SM' }),
      'flex',
      'border-none',
      'rounded-sm',
      'shadow-20',
      'py-2',
      'px-3',
      'max-w-[280px]',
      'transition-all',
      'duration-150',
      'z-1000',
    ],
    trigger: [
      'text-token-gray-700',
      'flex',
      'p-0',
      'items-center',
      'ml-1',
      'bg-none',
      'border-none',
      'cursor-default',
      'hover:cursor-default',
    ],
    triggerIcon: [],
    walletProfileContainer: ['py-3', 'px-2', 'flex', 'items-center', 'justify-between', 'w-full'],
    walletProfileLeftContainer: ['flex', 'items-center'],
    accessoryIcon: [
      'text-token-gray-700',
      'w-4',
      'h-4',
      'invisible',
      '[role=menuitem]:hover:visible',
    ],
  },
  variants: {},
});
